package com.exura.features.publicplans.domain.model

import com.exura.features.plandefinition.domain.model.PlanContentSummary
import com.exura.features.publicplans.data.remote.dto.PublicPlanServingEntryDto
import com.exura.features.storage.domain.model.DomainModel
import kotlinx.datetime.LocalDateTime

data class PublicPlanServingEntry(
    override val id: String?,
    val sharedFrom: LocalDateTime,
    val sharedTo: LocalDateTime?,
    val sharedPlanId: String,
    val summary: PlanContentSummary,
) : DomainModel<PublicPlanServingEntry, PublicPlanServingEntryDto> {
    override fun toDto(): PublicPlanServingEntryDto = PublicPlanServingEntryDto(
        sharedFrom = sharedFrom.toString(),
        sharedTo = sharedTo?.toString(),
        sharedPlanId = sharedPlanId,
        summary = summary,
    )

    override fun withId(id: String): PublicPlanServingEntry = copy(id = id)

    companion object : DomainModel.Factory<PublicPlanServingEntry, PublicPlanServingEntryDto> {
        override fun fromDto(id: String?, dto: PublicPlanServingEntryDto): PublicPlanServingEntry = PublicPlanServingEntry(
            id = id,
            sharedFrom = LocalDateTime.parse(dto.sharedFrom),
            sharedTo = dto.sharedTo?.let { LocalDateTime.parse(it) },
            sharedPlanId = dto.sharedPlanId,
            summary = dto.summary,
        )
    }
}
